import { render, staticRenderFns } from "./CurrentConferenceView.vue?vue&type=template&id=221c9fb1&"
import script from "./CurrentConferenceView.vue?vue&type=script&lang=ts&"
export * from "./CurrentConferenceView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports